export interface ConvertSvgToCoordinates {
  linePath: string[];
  polylinePath: string[];
}

const convertSvgToCoordinates = (id: string): ConvertSvgToCoordinates => {
  const word = document.getElementById(id);
  if (!word) throw new Error(`not found word by id ${id}`);
  const lines = word.getElementsByTagName('line');
  const polyline = word.getElementsByTagName('polyline');

  const linePath: string[] = [];
  const polylinePath: string[] = [];
  for (let i = 0; i < lines.length; i++) {
    const currentLine = lines[i];
    const x1 = currentLine.x1.baseVal.value;
    const x2 = currentLine.x2.baseVal.value;
    const y1 = currentLine.y1.baseVal.value;
    const y2 = currentLine.y2.baseVal.value;
    const parseLine = `${x1},${y1} ${x2},${y2}`;
    linePath.push(parseLine);
  }

  for (let i = 0; i < polyline.length; i++) {
    const currentPolyline = polyline[i];
    const polylinePoint = currentPolyline.getAttribute('points');
    if (polylinePoint) polylinePath.push(polylinePoint);
  }

  return { linePath, polylinePath };
};

export default convertSvgToCoordinates;
